import React from 'react';
import Icon from '../Icon';
import type { InboxThread } from '../../utils/inboxThreads';
import { formatListTime, initialsOf } from './formatMessageTime';

interface ThreadListProps {
  threads: InboxThread[];
  selectedKey: string | null;
  onSelect: (thread: InboxThread) => void;
}

const ThreadList: React.FC<ThreadListProps> = ({ threads, selectedKey, onSelect }) => (
  <ul className="communications-thread-list" aria-label="Conversations">
    {threads.map(thread => {
      const active = thread.key === selectedKey;
      return (
        <li key={thread.key}>
          <button
            type="button"
            className={`communications-thread-row${active ? ' communications-thread-row--active' : ''}${thread.unread > 0 ? ' communications-thread-row--unread' : ''}`}
            onClick={() => onSelect(thread)}
            aria-current={active ? 'true' : undefined}
          >
            <span className="communications-avatar" aria-hidden="true">{initialsOf(thread.label)}</span>
            <span className="communications-thread-row-body">
              <span className="communications-thread-row-top">
                <span className="communications-thread-row-name">{thread.label}</span>
                <span className="communications-thread-row-time">{formatListTime(thread.latest.created_at)}</span>
              </span>
              <span className="communications-thread-row-bottom">
                <span className="communications-thread-row-preview">{thread.latest.body || thread.latest.subject}</span>
                {thread.muted && (
                  <span className="communications-thread-row-muted" title="Muted">
                    <Icon name="eyeOff" size={12} />
                    <span className="sr-only">Muted</span>
                  </span>
                )}
                {thread.unread > 0 && (
                  <span className="communications-thread-row-badge" aria-label={`${thread.unread} unread`}>{thread.unread}</span>
                )}
              </span>
            </span>
          </button>
        </li>
      );
    })}
  </ul>
);

export default ThreadList;
